import Player from './player';
import Action from 'actions';
import Const from 'constants';
import {PlayersPoolBuilder} from 'services/players-pool/players-pool-builder';

export default class PlayerClassic extends Player {
    loadExtraPlayerDataFromStore({incomingValues: {dispatch, data}}) {
        // if (data.hasOwnProperty('correlationStackingSettings')) {
        //     dispatch(Action.set('CorrelationStackingSettingsFromStorage', data.correlationStackingSettings));
        // }

        // if (data.hasOwnProperty('correlationStackingPlayers')) {
        //     dispatch(Action.set('UsageOfPlayersOnlyInCorrelationStacking', data.correlationStackingPlayers));
        // }

        if (data.hasOwnProperty('teamNameStacking')) {
            dispatch(Action.set('TeamNameStackingFromStorage', data.teamNameStacking));
        }

        if (data.hasOwnProperty('avoidFewPassReceivers')) {
            dispatch(Action.set('AvoidFewPassReceiversFromStorage', data.avoidFewPassReceivers));
        }

        if (data.hasOwnProperty('flexMaxExposurePositions')) {
            dispatch(Action.set('FlexMaxExposurePositionsFromStorage', data.flexMaxExposurePositions));
        }
    }

    getExtraPlayerDataToStore({...rest}) {
        const {
            correlationStacking: {players},
        } = Action.getState();
        const correlationStackingPlayers = players.all();

        return {correlationStackingPlayers};
    }

    getExpandedEntityParams({incomingValues = {}}) {
        const expandedPlayer = super.getExpandedEntityParams({incomingValues});

        return {
            ...expandedPlayer,
            isFitForLineup(substitutablePlayer) {
                const substitutePlayerLineupPositions = this.positionName.split('/');
                if (substitutablePlayer.positionInLineup === Const.POSITION_FLEX) {
                    return substitutePlayerLineupPositions.some((position) => inArray(position, ['RB', 'WR', 'TE']));
                }

                return substitutePlayerLineupPositions.some(
                    (position) => substitutablePlayer.positionInLineup === position,
                );
            },
        };
    }

    createPoolsOfPlayers({incomingValues: {players}}) {
        const {playersLock} = Action.getState();

        let builder = new PlayersPoolBuilder(players);

        builder.addTaskOnScenario('position');
        builder.addTaskOnScenario('playerId');
        builder.addTaskOnScenario('teamAndPosition');
        builder.addTaskOnScenario('allowedPositions');
        builder.addTaskOnScenario('gameTeamPosName');
        builder.addTaskOnScenario('externalId');
        builder.addTaskOnProperty('gameInfo');
        builder.addTaskOnProperty('team');
        builder.addTaskOnProperty('exposureMin', function (player) {
            return !playersLock.isLockedAnywhere(player.getId()) && player.exposureMin > 0;
        });
        builder.addTaskOnProperty('exposureMax', function (player) {
            return !playersLock.isLockedAnywhere(player.getId()) && player.exposureMax < 100;
        });

        return builder.execTasks();
    }
}
